export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5325.edb10e8f.jpg";